import api from '@/plugins/api';

export const dashboardService = {
    getDashboard() {
        return api.get('/dashboard');
    },
};
